import React, { useState, useCallback, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import DragZone from "./DragZone";
import { getFileSize } from "../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import useFileUpload from "../api/hooks/useFileUpload";
import LoadingButton from "./LoadingButton";
import { useCreateContract } from "../api/hooks/contracts";
import "../scss/IA.scss";
import IAPic from "../images/iamodal.svg";
import { ContinuousColorLegend } from "react-vis";
import { useProfile } from "../api/hooks/profile";
import UploadProgressBar from "./ProgressBar";
const UploadPdfModal = (props) => {
  const { className, buttonProps, children } = props;
  const { profile, can } = useProfile();
  const { t } = useTranslation("common");
  const history = useHistory();
  const [files, setFiles] = useState([]);
  const [pdfAI, setpdfAI] = useState(null);
  const [AIAnalysis, setAIAnalysis] = useState(false);
  const [IsAIAnalysis, setIsAIAnalysis] = useState(false);
  const [requestIA, setRequestIA] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [totalToUpload, setTotalToUpload] = useState(0);
  const [uploadedSize, setUploadedSize] = useState(0);
  const { mutate: mutateCreateContract, isLoading: creatingContract } =
    useCreateContract({
      onSuccess: ({ data }) => {
        console.log(data);
        setFiles([]);
        // editorDispatch({ type: SET_DOCUMENT, document: createContractPayload?.data, setOriginal: true })
        history.replace(`/documents/${data._id}/edit`);
        // history.push(`/documents/${createContractPayoadinoad?.data?._id}/edit`)
      },
      onError: () => {
        toast.error(t("errorMessages.templateUploaded"));
      },
    });
  const onUploadProgress = (progressEvent) => {
    setUploadedSize(uploadedSize + progressEvent?.loaded);
    console.log("progress", progressEvent?.loaded);
  };
  const { uploadFile, uploadFileState } = useFileUpload({
    onSuccess: ({ url, BaseFileName, fileId }) => {
      console.log(uploadFileState);
      mutateCreateContract({
        name: BaseFileName,
        fileId,
        url,
        aiAnalysis:
          AIAnalysis &&
          AIAnalysis !==
            "no es contrato de arrendamiento de inmueble ni de compraventa"
            ? JSON.stringify(AIAnalysis)
            : false,
      });
    },

    onError: (error) => {
      toast.error(
        t(`errors.${error?.message}`, t("errorMessages.generalError"))
      );
    },
    onUploadProgress: onUploadProgress,
  });

  const handleDrop = useCallback((acceptedFiles) => {
    setpdfAI(acceptedFiles);

    setFiles(
      acceptedFiles.map((file) => {
        const fileSize = getFileSize(file.size);

        return Object.assign(file, {
          fileSize: `${fileSize.amount.toFixed(2)} ${fileSize.type}`,
        });
      })
    );
  }, []);

  const requestIAanalysis = async (file) => {
    const data = new FormData();
    data.append("files", file);

    await axios
      .post("https://ai.api.trato.io/analyzer/contrato", data, {
        onUploadProgress: onUploadProgress,
      })
      .then(function (response) {
        console.log(response);
        const analysis = Object.values(response.data[0])[0];
        setAIAnalysis(analysis);
        setIsAIAnalysis("loaded");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleSubmit = () => {
    if (requestIA) {
      requestIAanalysis(files[0]);
      setIsAIAnalysis("loading");
      setTotalToUpload(totalToUpload + files[0]?.size * 2.1);
    }
    if (!requestIA) {
      setTotalToUpload(totalToUpload + files[0]?.size * 1.1);
      uploadFile({ file: files[0] });
    }
  };
  useEffect(() => {
    console.log(AIAnalysis);
    if (AIAnalysis || AIAnalysis === null) {
      uploadFile({ file: files[0] });
      if (
        AIAnalysis ===
        "no es contrato de arrendamiento de inmueble ni de compraventa"
      ) {
        toast.error(
          "No es contrato de arrendamiento de inmueble ni de compraventa"
        );
      }
    }
    console.log(AIAnalysis);
    if (AIAnalysis || AIAnalysis === null) {
      console.log("is Null");
    }
  }, [AIAnalysis]);
  useEffect(() => {
    console.log(can("ANALYZE_PDF_DOCUMENTS"));
    console.log(!can("ANALYZE_PDF_DOCUMENTS"));
  }, []);

  const toggle = () => {
    setIsOpen(!isOpen);
    setFiles(null);
  };

  return (
    <>
      <Button {...buttonProps} onClick={toggle}>
        {children}
      </Button>
      <Modal isOpen={isOpen} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{t("uploadPdfModal.title")}</ModalHeader>
        <UploadProgressBar
          loaded={uploadedSize}
          totalToUpload={totalToUpload}
        />
        <ModalBody>
          <div className="text-center mb-2">
            <p className="font-weight-bold mb-1">{t("uploadPdfModal.text1")}</p>
            <p className="font-weight-bold">{t("uploadPdfModal.text2")}</p>
            <div className="p-2">
              <FontAwesomeIcon
                className="text-accent"
                icon="file-alt"
                size="3x"
              />
            </div>
          </div>
          <div className="uploadPDFModal--IA">
            <div className="header1">
              <div className="title">
                <h2>{t("uploadPdfModal.AIFeature.title")}</h2>
              </div>

              <div className="BETA--sign">BETA</div>
            </div>

            <p className="IA--Modal--text1">
              {t("uploadPdfModal.AIFeature.text1")}
            </p>
            <div className="picContainer">
              <img src={IAPic} alt="" />
            </div>
            <p className="IA--Modal--text2">
              {t("uploadPdfModal.AIFeature.text2")} <br />
              {t("uploadPdfModal.AIFeature.text4")}
            </p>
            {!can("ANALYZE_PDF_DOCUMENTS") && (
              <div className="noIA--analysis">
                <div className="unableToggle">
                  <div className="unableToggle--button">
                    <div></div>
                  </div>
                  <p className="unableToggle--legend">
                    {t("uploadPdfModal.AIFeature.text3")}
                  </p>
                </div>

                <p className="legend">
                  {t("uploadPdfModal.AIFeature.noAccess.0")}{" "}
                  <Link to="/plans/monthly">
                    {t("uploadPdfModal.AIFeature.noAccess.1")}
                  </Link>
                </p>
              </div>
            )}
            {can("ANALYZE_PDF_DOCUMENTS") && (
              <div className="enableIA--analysis">
                <div className="enableToggle">
                  <div
                    className={
                      requestIA
                        ? "enableToggle--button active"
                        : "enableToggle--button noActive"
                    }
                    onClick={() => setRequestIA(!requestIA)}
                  >
                    <div></div>
                  </div>
                  <p className="enableToggle--legend">
                    {t("uploadPdfModal.AIFeature.text3")}
                  </p>
                </div>
              </div>
            )}
          </div>
          {files?.map((file) => (
            <div
              className="d-flex mb-1 mr-1 align-items-center justify-content rounded p-3 bg-grey"
              key={file.name}
            >
              <FontAwesomeIcon className="color-accent" icon="file" size="2x" />
              <div className="d-flex flex-column ml-3">
                <span>{file.name}</span>
                <span className="text-muted">{file.fileSize}</span>
              </div>
            </div>
          ))}

          {!files?.length && (
            <DragZone
              multiple={false}
              // imgSrc="/images/listing/createDocument/subir.svg"
              label={t("actions.uploadDocument")}
              className="frontdesk-drag bg-indigo-10"
              acceptedFiles={["application/pdf"]}
              // noClick={() => { }}
              version={2}
              icon="cloud-upload-alt"
              // handleFile={onDrop}

              onDrop={handleDrop}
            />
          )}
        </ModalBody>
        <ModalFooter>
          <div className="mx-auto">
            <Button color="accent" onClick={toggle}>
              {t("actions.close")}
            </Button>
            {!IsAIAnalysis ? (
              <LoadingButton
                className="ml-2"
                color="accent-100"
                onClick={handleSubmit}
                loading={uploadFileState.isLoading || creatingContract}
                loadingText={t("actions.uploading")}
                disabled={files?.length < 1}
              >
                {t("actions.upload")}
              </LoadingButton>
            ) : (
              (IsAIAnalysis === "loading" || IsAIAnalysis === "loaded") && (
                <LoadingButton
                  className="ml-2"
                  color="accent-100"
                  onClick={handleSubmit}
                  loading={
                    uploadFileState.isLoading ||
                    creatingContract ||
                    IsAIAnalysis === "loading"
                  }
                  loadingText={
                    IsAIAnalysis === "loading"
                      ? t("uploadPdfModal.AIFeature.loading")
                      : t("actions.uploading")
                  }
                  disabled={files?.length < 1}
                >
                  {t("actions.upload")}
                </LoadingButton>
              )
            )}
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default UploadPdfModal;
